import { palette } from '@dev/ee-components';
import styled from 'styled-components';
import { Collapse, Grid } from '@material-ui/core';

export const OnboardingCardTitle = styled.div`
    display: flex;
    padding-block: 40px;
    align-items: center;
    svg {
        width: 32px;
        height: 32px;
        margin-right: 24px;
    }
`;

export const OnboardingCardHeaderWrapper = styled(Grid)<{
    $isOpen: boolean;
    $isTaskCompleted: boolean;
    $isMobile: boolean;
}>`
    padding-inline: ${({ $isMobile }): string => ($isMobile ? '20px' : '80px')};
    cursor: pointer;
    transition: background 0.3s;

    :hover {
        background: ${({ $isOpen, $isTaskCompleted }) =>
            $isOpen && !$isTaskCompleted ? `${palette.indigo[2]}` : 'none'};
    }

    .typography-text-box {
        color: ${({ $isTaskCompleted }) => $isTaskCompleted && `${palette.gray[4]}`};
    }
`;

export const OnboardingCardCounter = styled.div<{ $isTaskCompleted: boolean }>`
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${palette.gray[3]};
    border-radius: 50%;
    background: ${({ $isTaskCompleted }) => $isTaskCompleted && palette.green[1]};
`;

export const OnboardingCardWithTopBorder = styled.div`
    padding-block: 40px;
`;

export const OnboardingCardStyledCollapse = styled(Collapse)<{ $isMobile: boolean }>`
    padding-inline: ${({ $isMobile }): string => ($isMobile ? '20px' : '80px')};
`;

export const OnboardingCardStyledSteps = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    .stepWrapper {
        border: none;
        row-gap: 16px;
        & > div {
            border: 1px solid ${palette.gray[3]};
        }
    }
`;

export const OnboardingTaskMarkupWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 16px;
    color: ${palette.gray[5]};
    padding-block: 10px;
`;

export const RadioWrapper = styled.div`
    margin-bottom: 48px;

    & [role='radiogroup'] {
        flex-direction: row;
    }
`;
